import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentalConditionService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllEnvironmentalCondition(page, size,kindId?:number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.EnvironmentalCondition,
      queryString: `Page=${page}&Size=${size}&kindId=${kindId}`
    });
    return await firstValueFrom(observable);
  }

  async update(id,kindId, name) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.EnvironmentalCondition
    }, {
      id: id,
      kindId:kindId,
      environmentalContent: name
    });
    return await firstValueFrom(observable);
  }

  async create(kindId: number, environmentalContent: any[]) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.EnvironmentalCondition
    }, {
      kindId: kindId,
      environmentalContent: environmentalContent
    });
    return await firstValueFrom(observable);
  }


  async getByIdEnvironmentalCondition(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.EnvironmentalCondition
    },id);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
